import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Pages/Home';
import logo from './logo.svg';
import './App.css';
import Login from './Pages/Admin/Login';
import ForgotPassword from './Pages/Admin/ForgotPassword';
import ResetPassword from './Pages/Admin/ResetPassword';
import AdminHome from './Pages/Admin/AdminHome';
import ViewUser from './Pages/Admin/ViewUser';
import ViewHome from './Pages/HomePage/View';
import AddHomeImage from './Pages/HomePage/AddHomePageImage';
import EditHome from './Pages/HomePage/Edit';
import BusinessStory from './Pages/BusinessPage/BusinessStory';
import BusinessVision from './Pages/BusinessPage/BusinessVision';
import BusinessPartners from './Pages/BusinessPage/BusinessPartners';
import EditVisionText from './Pages/BusinessPage/EditPartnershipText';
import EditPartnershipImage from './Pages/BusinessPage/EditPartnershipImage';
import StoriesList from "./Pages/News/StoriesList";
import CreateNewsPost from "./Pages/News/CreateNewsPost";
import EditNewsPost from "./Pages/News/EditNewsPost";
import PodcastsList from "./Pages/News/PodcastsList";
import AddNewPodcast from "./Pages/News/AddNewPodcast";
import EditPodcast from "./Pages/News/EditPodcast";
import InsightsList from "./Pages/News/InsightsList";
import AddInsight from "./Pages/News/AddInsight";
import EditInsight from "./Pages/News/EditInsight";
import VacanciesList from "./Pages/Vacancies/VacanciesList";
import AddVacancy from "./Pages/Vacancies/AddVacancy";
import EditVacancy from "./Pages/Vacancies/EditVacancy";
import WinesList from "./Pages/Wines/WinesList";
import ViewWine from "./Pages/Wines/ViewWine";
import OfficesList from "./Pages/Contact/OfficesList";
import AddOffice from "./Pages/Contact/AddOffice";
import EditOffice from "./Pages/Contact/EditOffice";
import CustomerEnquiryList from "./Components/Customer/CustomerEnquiryList";
import OurStory from "./Pages/OurStory";
import Vision from "./Pages/Vision";
import Partnership from "./Pages/Partnership";
import Brands from "./Pages/Brands";
import WineBrands from "./Pages/Wines/WineBrands";
import EditBrandHero from './Pages/Wines/EditBrandHero';
import Brand from "./Pages/Brand";
import TradeWithUs from "./Pages/TradeWithUs";
import Export from "./Pages/Export";
import Careers from "./Pages/Careers";
import Career from "./Pages/Career";
import NewsStories from "./Pages/NewsStories";
import NewsStory from "./Pages/NewsArticles/NewsStory";
import Webinars from "./Pages/Webinars";
import Podcasts from "./Pages/Podcasts";
import Products from "./Pages/Products";
import CustomerLogin from "./Pages/CustomerLogin";
import Offices from "./Pages/Offices";
import Subscribe from "./Pages/Subscribe";
import Terms from "./Pages/Terms";
import FilteredProducts from "./Pages/FilteredProducts";
import Webinar from "./Pages/Webinar";
import Podcast from "./Pages/Podcast";
import Search from "./Pages/Search";
import Sustainability from "./Pages/Sustainability";
import TermsOfSales from "./Pages/TermsOfSales";
import Disclaimer from "./Pages/Disclaimer";
import OurApproach from "./Pages/OurApproach";
import EditOurApproachPage from "./Pages/BusinessPage/EditOurApproachPage";
import NotFound from "./Pages/NotFound";
import ViewAll from "./Pages/Documents/ViewAll";
import AddDocument from "./Pages/Documents/AddDocument";
import ViewGalleries from "./Pages/Galleries/ViewGalleries";
import AddGallery from "./Pages/Galleries/AddGallery";
import EditGallery from "./Pages/Galleries/EditGallery";
import Galleries from "./Pages/Galleries";
import Gallery from "./Pages/Gallery";
import CreateNewsPost2 from "./Pages/News/CreateNewsPost2";
import NewsPosts from "./Pages/NewsArticles/NewsPosts";
import CreateCustomArticle from "./Pages/News/CustomArticle/CreateCustomArticle";
import EditOrder from "./Pages/News/CustomArticle/EditOrder";
import AgeGate from './Components/AgeGate/AgeGate';

function App() {
    return (
        <Router>
            <div className="App">
                <AgeGate />
                <Routes>
                    <Route path="/" element={<Home/>}/>
                    <Route path="*" element={<NotFound/>}/>
                    <Route path="/login" element={<Login/>}/>
                    <Route path="/forgot-password" element={<ForgotPassword/>}/>
                    <Route path="/reset" element={<ResetPassword/>}/>
                    <Route path="/dashboard" element={<AdminHome/>}/>
                    <Route path="/view-user" element={< ViewUser/>}/>

                    <Route path="/dashboard/home/images" element={<ViewHome/>}/>
                    <Route path="/dashboard/home/add-home-images" element={<AddHomeImage/>}/>
                    <Route path="/dashboard/home/edit-home-images" element={<EditHome/>}/>

                    <Route path="/dashboard/business/our-story" element={<BusinessStory/>}/>
                    <Route path="/dashboard/business/our-vision" element={<BusinessVision/>}/>
                    <Route path="/dashboard/business/partnership" element={<BusinessPartners/>}/>
                    <Route path="/dashboard/business/partnership/edit" element={<EditVisionText/>}/>
                    <Route path="/dashboard/business/partnership/edit-images" element={<EditPartnershipImage/>}/>
                    <Route path="/dashboard/business/our-approach" element={<EditOurApproachPage/>}/>

                    <Route path="/dashboard/news/list" element={<StoriesList/>}/>
                    <Route path="/dashboard/news/create/template1" element={<CreateNewsPost/>}/>
                    <Route path="/dashboard/news/create/template2" element={<CreateNewsPost2/>}/>
                    <Route path="/dashboard/news/:template/:id/edit" element={<EditNewsPost/>}/>
                    <Route path="/dashboard/news/create/custom" element={<CreateCustomArticle /> } />
                    <Route path="/dashboard/news/edit-order/:id" element={<EditOrder/>} />

                    <Route path={"/dashboard/podcasts/list"} element={<PodcastsList/>}/>
                    <Route path={"/dashboard/podcasts/create"} element={<AddNewPodcast/>}/>
                    <Route path={"/dashboard/podcasts/:id/edit"} element={<EditPodcast/>}/>

                    <Route path={"/dashboard/insights/list"} element={<InsightsList/>}/>
                    <Route path={"/dashboard/insights/create"} element={<AddInsight/>}/>
                    <Route path={"/dashboard/insights/:id/edit"} element={<EditInsight/>}/>

                    <Route path={"/dashboard/vacancies/list"} element={<VacanciesList/>}/>
                    <Route path={"/dashboard/vacancies/create"} element={<AddVacancy/>}/>
                    <Route path={"/dashboard/vacancies/:id/edit"} element={<EditVacancy/>}/>

                    <Route path={"/dashboard/wines/list"} element={<WinesList/>}/>
                    <Route path={"/dashboard/wines/show"} element={<ViewWine/>}/>
                    <Route path={"/dashboard/wines/brands"} element={<WineBrands/>}/>
                    <Route path={"/dashboard/wines/brands/edit"} element={<EditBrandHero/>}/>

                    <Route path={"/dashboard/offices/list"} element={<OfficesList/>}/>
                    <Route path={"/dashboard/offices/add"} element={<AddOffice/>}/>
                    <Route path={"/dashboard/offices/:id/edit"} element={<EditOffice/>}/>

                    <Route path={"/dashboard/documents/list"} element={<ViewAll/>}/>
                    <Route path={"/dashboard/documents/new"} element={<AddDocument/>}/>

                    <Route path={'/dashboard/galleries/list'} element={<ViewGalleries/>}/>
                    <Route path={'/dashboard/galleries/new'} element={<AddGallery/>}/>
                    <Route path={'/dashboard/galleries/:id/edit'} element={<EditGallery/>}/>

                    {/*<Route path={"/dashboard/customers/enquiries"} element={<CustomerEnquiryList />} />*/}

                    {/*  WEB APP ROUTES  */}
                    <Route path="/about/our-story" element={<OurStory/>}/>
                    <Route path="/about/vision" element={<Vision/>}/>
                    <Route path="/about/partnership" element={<Partnership/>}/>
                    <Route path="/about/our-approach" element={<OurApproach/>}/>
                    <Route path="/our-wines" element={<Brands/>}/>
                    <Route path="/our-wines/:brand" element={<Brand/>}/>
                    <Route path={"/our-wines/:brand/:product"} element={<Products/>}/>
                    <Route path="/trade-with-us" element={<TradeWithUs/>}/>
                    <Route path="/about/export" element={<Export/>}/>
                    <Route path="/vacancies" element={<Careers/>}/>
                    <Route path="/vacancies/:slug" element={<Career/>}/>
                    <Route path="/news" element={<NewsStories/>}/>
                    <Route path="/news/:slug" element={<NewsPosts/>}/>
                    <Route path="/webinars" element={<Webinars/>}/>
                    <Route path="/webinars/:slug" element={<Webinar/>}/>
                    <Route path="/podcasts" element={<Podcasts/>}/>
                    <Route path="/podcasts/:slug" element={<Podcast/>}/>
                    <Route path="/galleries" element={<Galleries/>}/>
                    <Route path="/galleries/:slug" element={<Gallery/>}/>
                    <Route path="/customer-login" element={<CustomerLogin/>}/>
                    <Route path="/contact" element={<Offices/>}/>
                    <Route path="/subscribe" element={<Subscribe/>}/>
                    <Route path="/terms" element={<Terms/>}/>
                    <Route path="/products" element={<FilteredProducts/>}/>
                    <Route path="/search" element={<Search/>}/>
                    <Route path="/sustainability" element={<Sustainability/>}/>
                    <Route path="/terms-of-sales" element={<TermsOfSales/>}/>
                    <Route path="/disclaimer" element={<Disclaimer/>}/>

                </Routes>
            </div>
        </Router>
    );
}

export default App;
